import { getQueryKey } from 'utils';

import { useQuery } from '../tanstack';
import { Args, OfficeholdersDataSource, ShareholdersDataSource } from './types';

const useCompanyHolders = <SubRoute extends 'officeholders' | 'shareholders'>({
  companyID,
  cognitoID,
  subRoute,
}: Args<SubRoute>) => {
  const queryKey = getQueryKey(subRoute, companyID);

  const { data = [], isLoading } = useQuery<
    SubRoute extends 'officeholders'
      ? OfficeholdersDataSource[]
      : ShareholdersDataSource[]
  >({
    apiName: 'client',
    path: `/${cognitoID}/companies/${companyID}/${subRoute}`,
    queryKey,
  });

  return {
    data,
    isLoading,
    queryKey,
  };
};

export default useCompanyHolders;
